// removed by extract-text-webpack-plugin
module.exports = {"button":"LoginForm__button___VUF0O"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/login/LoginForm.css
// module id = 531
// module chunks = 0